import React, {useState} from 'react'
import { AuthContext } from '../contexts/AuthContext';
import { Navigate } from "react-router-dom";

function AuthProvider({ children }: { children: React.ReactNode }) {
    let [user, setUser] = useState(() => {
        let userData = localStorage.getItem('user_data') != 'undefined' ? JSON.parse(localStorage.getItem('user_data')!) : null;
        return userData;
    })
    let [isAuth, setIsAuth] = useState(() => {
        let token = localStorage.getItem('access_token') ? true : false;
        return token;
    })

    const login =(data: {})=>{
        localStorage.setItem('user_data', JSON.stringify(data))
        setIsAuth(true)
        setUser( data )
        // return <Navigate to="/simcard"/>
    }

    const logout =()=>{
        localStorage.removeItem('user_data')
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        setIsAuth(false)
        setUser( null )
    }
    // const checkTokenExist = () => {
    //     let exist = localStorage.getItem('access_token') ? true : false;
    //     if (exist && !user) {
    //         console.log(11, user)
    //         setUser(localStorage.getItem('user_data'))
    //     }
    //     return exist
    // };


    // let saveUserToLocalStorage = (data: {}) => {
    //     localStorage.setItem('user_data', JSON.stringify(data))
    //     return true
    // };

    // function user() {
    //     let data = localStorage.getItem('user_data')
    //     return JSON.parse(data!)
    // }
    let value = { login, isAuth, user, logout}
  
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export default AuthProvider